export default "__VITE_ASSET__B54aOn1J__"